import UserInfoContextProvider from './UserInfoContextProvider';

export default UserInfoContextProvider;
